import { matchdayApi, teamApi } from '@/api/endpoints';
import type { Matchday, Team } from '@/api/types';
import { Alert, Spinner } from '@/components/ui';
import { isPastDeadline } from '@/lib/datetime';
import { QuestionsBlock, type QuestionsBlockData } from '@/features/questions/QuestionsBlock';
import { useAsync } from '@/lib/useAsync';

/** Tippseite für Bonus-Spieltage (kind='bonus'): statt Scoreboard die Fragenliste. */
export function BonusMatchdayPage({ matchday }: { matchday: Matchday }) {
  const matchdayId = matchday.id;

  const { data, loading, error } = useAsync<QuestionsBlockData>(
    async (signal) => {
      const [resp, teams] = await Promise.all([
        matchdayApi.questions(matchdayId, signal),
        teamApi.listLeague(signal).catch(() => [] as Team[]),
      ]);
      return {
        matchday: resp.matchday ?? matchday,
        questions: [...resp.questions].sort((a, b) => a.sort_order - b.sort_order),
        myAnswers: resp.my_answers ?? [],
        solution: resp.solution ?? [],
        deadlinePassed: resp.deadline_passed ?? isPastDeadline(matchday.deadline_at),
        teams,
      };
    },
    [matchdayId],
  );

  if (loading) return <Spinner label="Fragen werden geladen…" />;
  if (error) return <Alert>{error}</Alert>;
  if (!data) return <Alert>Keine Daten.</Alert>;
  if (data.questions.length === 0) {
    return <Alert>Für diesen Bonus-Spieltag sind noch keine Fragen hinterlegt.</Alert>;
  }

  return <QuestionsBlock data={data} />;
}
